import { render, staticRenderFns } from "./DvjButton.vue?vue&type=template&id=7b4d0dfb&scoped=true&"
import script from "./DvjButton.vue?vue&type=script&lang=js&"
export * from "./DvjButton.vue?vue&type=script&lang=js&"
import style0 from "./DvjButton.vue?vue&type=style&index=0&id=7b4d0dfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d0dfb",
  null
  
)

export default component.exports